import { Icon } from "./Icon";
import type { IconName } from "../data/portfolio";
import { cn } from "../lib/cn";

const VARIANTS = {
  outline:
    "border-hairline bg-subtle hover:border-hairline-hover",
  plain: "border-transparent bg-transparent hover:bg-subtle",
} as const;

interface IconButtonProps {
  icon: IconName;
  label: string;
  href?: string;
  variant?: keyof typeof VARIANTS;
  onClick?: () => void;
}

/** 40px circular icon-only control — footer socials and the mobile menu toggle. */
export function IconButton({
  icon,
  label,
  href,
  variant = "outline",
  onClick,
}: IconButtonProps) {
  const classes = cn(
    "text-muted hover:text-strong ease-standard inline-flex size-10 items-center justify-center rounded-full border transition duration-200",
    VARIANTS[variant],
  );

  if (href) {
    return (
      <a href={href} aria-label={label} className={classes}>
        <Icon name={icon} size={18} />
      </a>
    );
  }

  return (
    <button type="button" aria-label={label} onClick={onClick} className={classes}>
      <Icon name={icon} size={18} />
    </button>
  );
}
